/**
 * Decisions for native boot / Capgo reload session recovery.
 *
 * Capgo OTA applies a web bundle by reloading the WebView. The access token is
 * memory-only on native, so every OTA apply looks briefly "logged out" until
 * silent refresh finishes. Login-screen zombie cleanup must not treat that
 * window as a reason to delete the Keychain refresh token.
 */

/**
 * After `awaitBootGate()`, may LoginView destroy the Keychain refresh token?
 *
 * @param {object} opts
 * @param {boolean} opts.hasAccessToken silent refresh already restored the session
 * @param {boolean} opts.hasRefreshToken session or biometric refresh still present
 * @param {boolean} opts.preserveBiometric biometric / passkey unlock is configured
 * @returns {boolean} true only for a profile-only zombie (no credential left)
 */
export function shouldClearNativeRefreshOnLoginPurge({
  hasAccessToken,
  hasRefreshToken,
  preserveBiometric,
}) {
  if (hasAccessToken) return false
  if (preserveBiometric) return false
  // Boot already cleared 401/403-dead tokens. A surviving refresh is either a
  // live Capgo/cold-start session mid-recovery or a transient network failure.
  if (hasRefreshToken) return false
  return true
}
